
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { MediaType, mediaTypeRegExp } from '@/utils/mediaType'
import { ImageInterface, InputRule, loadImage, SizeRule } from '@/utils/image'
import { AppImagePreview } from '@/components'

@Component({
    components: {
        FontAwesomeIcon,
        AppImagePreview,
    },
})
export default class AppInputMultipleImages extends Vue {
    @Prop({ default: '' }) public title!: string
    @Prop({ default: undefined }) public subtitle?: string
    @Prop({ default: 'Escolha um arquivo' }) public inputTitle!: string
    @Prop({ default: undefined }) public inputSubtitle?: string
    @Prop({ default: undefined }) public tooltip?: string
    @Prop({ default: '' }) public error!: string
    @Prop({ default: undefined }) public inputRule?: InputRule
    @Prop({ default: () => [] }) public images!: Array<[number, ImageInterface]>
    @Prop({ default: () => [] }) public sizeRules!: SizeRule[]

    private oldImages: Array<[number, ImageInterface]> = this.images
    private newImages: Array<[number, ImageInterface]> = []

    get hasError() {
        return this.error && this.error.length > 0
    }

    get fileTypeAcceptance(): string {
        return 'image/jpeg, image/png, image/jpg'
    }

    get imagesToPreview(): Array<[number, ImageInterface]> {
        return this.oldImages.concat(this.newImages)
    }

    public launchFilePicker() {
        (this.$refs.file as any).click()
    }

    public onRemoveFile(image: [number, ImageInterface]) {
        if (image[0] === 0) {
            const newIndex = this.newImages.indexOf(image)

            if (newIndex > -1) {
                this.newImages.splice(newIndex, 1)

                this.$emit('imageRemoved', image)

                return
            }
        } else {
            const oldIndex = this.oldImages.indexOf(image)

            if (oldIndex > -1) {
                this.oldImages.splice(oldIndex, 1)

                this.$emit('imageRemoved', image)

                return
            }
        }
    }

    public async onSubmitFile(e: Event) {
        const { files } = e.target as any

        if (files.length > 0) {
            for (const file of files) {
                const regex = mediaTypeRegExp(MediaType.IMAGE)

                if (!file.type.match(regex)) {
                    window.alert(
                        `O arquivo deve ser do formato ${regex}`,
                    )
                } else {
                    if (this.inputRule?.maximumNumber &&
                        this.imagesToPreview.length >= this.inputRule.maximumNumber) {
                        window.alert(
                            `Só é possível subir até ${this.inputRule.maximumNumber} imagens`,
                        )

                        break
                    }

                    loadImage(file, (imageElement, imageUrl) => {
                        if (this.validateImageSize(imageElement)) {
                            const image: [number, ImageInterface] = [
                                0,
                                { file, imageURL: imageUrl },
                            ]

                            this.newImages.push(image)
                            this.$emit('imageSubmitted', image)
                        } else {
                            window.alert(
                                `O arquivo ${file.name} não está na resolução correta`,
                            )
                        }
                    })
                }
            }
        }
    }

    // imageElement parameter type as any to work on test context
    // imageElement parameter should always be of type HTMLImageElement
    public validateImageSize(imageElement: any): boolean {
        if (this.sizeRules.length <= 0) {
            return true
        }

        return this.sizeRules.some((sizeRule) => {
            return sizeRule.width === imageElement.width && sizeRule.height === imageElement.height
        })
    }
}
